"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTerminateContractMeterPicture = exports.getTerminateContractRequest = exports.getOperationalDate = exports.getProductContractId = exports.getFirstProductContractName = exports.getProductContractState = exports.getProductContract = void 0;
/**
 * Récupère le state depuis le product contract
 * @param {*} store Store redux hébergeant le state
 */
function getProductContract(states) {
    return states.productContract.data;
}
exports.getProductContract = getProductContract;
function getProductContractState(states) {
    return states.productContract;
}
exports.getProductContractState = getProductContractState;
/**
 * Récupère le productContractName depuis le product contract
 * @param {*} store Store redux hébergeant le state
 */
function getFirstProductContractName(states) {
    var _a;
    var data = getProductContract(states);
    if (data)
        return (_a = data.lastProductInvoice) === null || _a === void 0 ? void 0 : _a.contractName;
    return null;
}
exports.getFirstProductContractName = getFirstProductContractName;
/**
 * Récupère le productContractId depuis le product contract
 * @param {*} store Store redux hébergeant le state
 */
function getProductContractId(states) {
    var _a;
    var data = getProductContract(states);
    if (data)
        return (_a = data.lastProductInvoice) === null || _a === void 0 ? void 0 : _a.productContractId;
    return null;
}
exports.getProductContractId = getProductContractId;
function getOperationalDate(states) {
    var _a;
    var data = getProductContract(states);
    if (data)
        return (_a = data.operationalDate) === null || _a === void 0 ? void 0 : _a.operationalDate;
    return null;
}
exports.getOperationalDate = getOperationalDate;
function getTerminateContractRequest(states) {
    return states.productContract.terminateContractRequest;
}
exports.getTerminateContractRequest = getTerminateContractRequest;
function getTerminateContractMeterPicture(states) {
    return states.productContract.terminateContractMeterPicture;
}
exports.getTerminateContractMeterPicture = getTerminateContractMeterPicture;
